<template>
  <header class="gg-header">
    <router-link class="gg-header__brand" to="/" aria-label="Globo Graphics — início">
      <span class="gg-header__logo">
        <GloboGraphicsLogo />
      </span>
      <span class="gg-header__divider" aria-hidden="true" />
      <span class="gg-header__title">Globo Graphics</span>
    </router-link>

    <div class="gg-header__actions">
      <AppProfile compact @advanced-settings="onAdvancedSettings" />
    </div>
  </header>
</template>

<script>
import AppProfile from "@/components/AppBar/AppProfile.vue";
import GloboGraphicsLogo from "@/assets/globo_graphics_logo.svg";

export default {
  name: "GloboGraphicsHeader",
  components: { AppProfile, GloboGraphicsLogo },
  methods: {
    // Sites and engines are module-wide, not per-production, so this is a route
    // rather than a dialog and needs no program selected.
    onAdvancedSettings() {
      if (this.$route.name === "globographics-configuracoes") return;
      this.$router.push({ name: "globographics-configuracoes" });
    },
  },
};
</script>

<style lang="scss" scoped>
.gg-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: var(--sc-space-2) var(--sc-space-6);
  background: var(--sc-gg-surface-1);
  border-bottom: 1px solid var(--sc-gg-border-100);
}

.gg-header__brand {
  display: flex;
  align-items: center;
  gap: var(--sc-space-5);
  padding: 0 var(--sc-space-2);
  text-decoration: none;
}

.gg-header__logo {
  display: block;
  width: 20px;
  height: 20px;
  color: var(--sc-gg-text-primary); // white globe (svg uses currentColor)

  ::v-deep svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.gg-header__divider {
  width: 1px;
  height: 20px;
  background: var(--sc-gg-text-primary);
}

.gg-header__title {
  // Wordmark stays in the Globo display face; the rest of the module uses Inter.
  font-family: "Globotipo", sans-serif;
  font-size: 20px;
  line-height: 24px;
  color: var(--sc-gg-text-strong);
  white-space: nowrap;
}

.gg-header__actions {
  display: flex;
  align-items: center;
  gap: var(--sc-space-2);
}
</style>
